module.exports = "<section class=\"container-fluid\">\n\n    <div class=\"article-title\">Blank</div>\n\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-layouts/fullscreen/fullscreen.component.html
// module id = 1274
// module chunks = 10